import classNames from "classnames";
import {Link, useLocation} from "react-router-dom";
import { useAuth } from '../../context/AuthContext';

// eslint-disable-next-line no-unused-vars
import {mainRoutes} from "../../routes";
import logoSrc from '../../img/logo.png';

const NavItem = ({ route }) => {
    const { path } = useLocation();
    const isActive = route.path === path;
    return (
        <li className="nav-item px-2 py-1">
            <Link
                className={classNames("nav-link text-red", {
                    active: isActive,
                    disabled: route.isDisabled,
                })}
                aria-current={isActive}
                to={route.path}
            >
                {route.name}
            </Link>
        </li>
    )
};

export const Navbar = () => {
    const { currentUser, isAdmin } = useAuth();

    return (
        <nav className="navbar navbar-expand-lg navbar-light fixed-top bg-light">
            <div className="container-fluid">
                <a className="navbar-brand" href="/">
                    <img src={logoSrc} height="30" width={30} alt="Bella's Mission" />
                </a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggler" aria-controls="navbarToggler" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarToggler">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        {mainRoutes.map((route, idx) => (
                            <NavItem key={`main-route-${idx}`} route={route} />
                        ))}
                    </ul>
                    
                    {/* Admin quick access - hidden but accessible via URL */}
                    {currentUser && isAdmin && (
                        <ul className="d-flex navbar-nav ms-auto">
                            <li className="nav-item">
                                <Link className="nav-link text-red" to="/admin">
                                    <small>Admin</small>
                                </Link>
                            </li>
                        </ul>
                    )}
                </div>
            </div>
        </nav>
    );
};
